export const trackModel = (res, user) => {
  const data = {
    id: '',
    title: "COPY - " + res.title,
    lat: res.lat,
    lng: res.lng,
    user,
    created: 0,
    images: [],
    imgids: "",
    videos: [],
    points: [],
    map_zoom: 0,
    map_type: "",
    link: "",
    shortdescription: "",
    description: "Tour description",
    duration: res.duration,
    distance: res.distance,
    rating: 0,
    tourType: 5,
    arrow_type: 0,
    url: "",
    s: "",
    private: true,
    share_key: "",
    bookmark: false,
    multiDay: false,
    parts: [
      {
        id: "",
        title: "COPY - " + res.title,
        description: "Tour description",
        images: [],
        points: res.points,
        allTourDays: 0,
        parentId: 0,
        multiDay: false,
        duration: 0,
        distance: 0
      }
    ]
  }
  return data;
};
